export function getTargetString(target, scale, abb) {
  let targetString = "";
  if (scale === "Number") {
    targetString = getNumberInText(target);
  } else if (scale === "Currency") {
    targetString = getAmountInText(target, abb);
  } else if (scale === "Percentage") {
    targetString = parseFloat(target).toFixed(2) + "%";
  } else {
    targetString = target + abb;
  }
  return targetString;
}

export function getAmountInText(amount, abb) {
  let currencyType = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: abb || "USD",
  });
  
  const isNegative = Number(amount) < 0;
  const absAmount = Math.abs(Number(amount));
  const sign = isNegative ? "-" : "";
  
  // Nine Zeroes for Billions
  return absAmount >= 1.0e9
    ? sign + currencyType.format(0).split("0")[0] +
        (absAmount / 1.0e9).toFixed(2) +
        "B"
    : // Six Zeroes for Millions
    absAmount >= 1.0e6
    ? sign + currencyType.format(0).split("0")[0] +
      (absAmount / 1.0e6).toFixed(2) +
      "M"
    : currencyType.format(amount); // This preserves the sign naturally
}

export function getNumberInText(amount) {
  let type = Intl.NumberFormat("en-US");
  
  const isNegative = Number(amount) < 0;
  const absAmount = Math.abs(Number(amount));
  const sign = isNegative ? "-" : "";
  
  // Nine Zeroes for Billions
  return absAmount >= 1.0e9
    ? sign + (absAmount / 1.0e9).toFixed(2) + "B"
    : // Six Zeroes for Millions
    absAmount >= 1.0e6
    ? sign + (absAmount / 1.0e6).toFixed(2) + "M"
    : type.format(amount); // This preserves the sign naturally
}
